<template>
  <div class="layout-padding">
    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      :title="$route.query.title + ' 게시글 조회'"
      desc="등록된 게시물의 현황을 조회할 수 있습니다."
    ></admin-filter>

    <div class="btn-group-justify-end">
      <button @click="clickWriteEvent" class="button is-primary">글쓰기</button>
    </div>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="1100"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">

      <div slot="modify_delete" slot-scope="props">
        <button class="button" @click.stop.prevent="clickItem(props.item,'update')" style="margin-right:4px">수정</button>
        <button class="button is-danger" @click.stop.prevent="clickItem(props.item,'delete')">삭제</button>
      </div>
    </admin-table>

  </div>
</template>

<script>
import ListMixin from '@/mixins/ListMixin'
import AdminFilter from "../../module/admin/AdminFilter";
import AdminTable from "../../module/admin/AdminTable";

export default {
  name: 'PostList',
  layout: "Main",
  mixins: [
    ListMixin
  ],
  components: {
    AdminTable,
    AdminFilter
  },
  created() {
    this.init();
  },
  data() {
    return {}
  },
  watch: {
    '$route'(n){
      this.initializing('post', 'board/' +this.$route.params.id + '/post');
    }
  },
  methods: {
    init() {
      this.initializing('post', 'board/' +this.$route.params.id + '/post');
    },
    getDataFromServer() {
      this.getData();
    },
    // 글쓰기 버튼 클릭
    clickWriteEvent() {
      this.$router.push('post/create?title='+this.$route.query.title);
    },
    clickItem(item, kind) {
      if (kind === "update") {
        this.$router.push('post/create?id=' + item.id+'&title='+this.$route.query.title);
      } else if (kind === "delete") {

        let value = {
          id: item.id,
          url: 'board/' +this.$route.params.id + '/post/',
          title: '게시물을 삭제하시겠습니까?'
        }
        this.$store.commit('openModal', {type: 'modal-delete', value: value, width: 500});
      }
    }
  }
};
</script>

<style lang="stylus" type="stylus" scoped>
////@import '~assets/css/reset';
//@import '~assets/css/lp_main';

.tr-whole-border th {
  padding: 12px 6px;
}

.many-field-tr td {
  padding: 6px;
}

.progress-btn {
  border-radius: 3px;
  display: inline-block;
  width: 84px;
  padding: 6px 0;
  margin: 2px;
  font-weight: bold;
  font-size: 0.8rem;
}

.btn-confirm-new-req {
  background-color: #ffb100;
  color: #fff;
}

.btn-stand-by-ests {
  color: #064160;
  font-weight: bold;
}

.btn-write-sheet {
  background-color: $primary;
  color: #fff;
}

.bid-state {
  margin: 2px 0;
  color: #fff;
  border-radius: 3px;
  display: inline-block;
  width: 76px;
  padding: 4px;
}

.bid-state-ing {
  background-color: #1c7cd5;
}

.bid-state-ok {
  background-color: #5cb85c;
}

.bid-state-no {
  background-color: #f0ad4e;
}
</style>
